import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import RankLabelSwitch from './RankLabelSwitch';

interface IRatingDetails {
   cnRank?: number;
   candidRank?: number;
   handleCandidRank?: () => void;
   handleCnRank?: () => void;
}

const RatingDetails: React.FC<IRatingDetails> = ({ cnRank, candidRank, handleCnRank, handleCandidRank }) => {
   return (
      <Box
         sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', py: 2.5 }}
      >
         <Typography sx={{ fontSize: '14px', lineHeight: '17px', fontWeight: 600, color: '#999999' }}>
            Rating
         </Typography>
         <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', columnGap: 2 }}>
            {cnRank && (
               <Button sx={{ width: 80, height: 80, p: 0 }} onClick={handleCnRank}>
                  <RankLabelSwitch labelOf='cnRank' rank={cnRank} />
               </Button>
            )}
            {candidRank && (
               <Button sx={{ width: 80, height: 80, p: 0 }} onClick={handleCandidRank}>
                  <RankLabelSwitch labelOf='candidRank' rank={candidRank} />
               </Button>
            )}
         </Box>
      </Box>
   );
};

export default RatingDetails;
